<template>
  <div class="content">
    <div style="font-weight: bold;margin-top: 30px;font-size: 16px">{{ company.title }}</div>
    <div style="margin-top: 20px;text-indent: 2em;text-align: left;"> {{ company.cont }}</div>
    <!--      <div style="margin-top:25px">联系电话:13979894546</div>-->
    <div style="margin-top: 20px">
      <img :src="company.after_sales_qrcode" width="100%" />
      <div>售后二维码 联系我们</div>
      <div style="margin:20px;font-size: 30px;font-weight: bolder" v-if="company.after_sales_tel !== ''">
        <span style="font-size: 16px">售后电话：</span>
        {{ company.after_sales_tel }}
      </div>
    </div>

    <div style="margin:30px 0" v-if="brand.length > 0">
      <table border="1" width="100%" height="100px" align="center" bordercolor="black" cellspacing="5" cellpadding="5">
        <!-- 2.创建行 -->
        <tr style="border: 1px solid black;">
          <th style="padding:15px 0 15px 0">品牌logo/二维码</th>
          <th>品牌名称/简介</th>
        </tr>
        <tr v-for="item in brand">
          <td>
            <img :src="item.logo" width="120" />
          </td>
          <td>{{ item.name }}</td>
        </tr>

        <tr v-for="item in brand">
          <td>
            <img :src="item.qr_code" width="120" />
          </td>
          <td>{{ item.describe }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "hl-company",
  data() {
    return {
      company: '',
      brand: [],
    }
  },
  mounted() {
    const code = this.$route.query.id || this.$route.query.code || '';
    if (code) {
      sessionStorage.setItem('id', code);
      this.axios.get(`/qrcode/source_by_code?code=${code}`).then(res => {
        if (res.data.code !== 500) {
          this.company = res.data.data.company;
          this.brand = res.data.data.brand;
        }
      })
      // axios({
      //   url: `https://gcds.thinkerx.com/api/qrcode/source?id=${this.$route.query.id}`,
      //   methods: 'get',
      // }).then(res=>{
      //   if(res.data.code!==500){
      //     this.company=res.data.data.company;
      //     this.brand=res.data.data.brand;
      //   }
      // })
    }
  }
}
</script>

<style scoped>
.content {
  padding: 30px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/hl-company.vue